// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"c479d2e6","675":"4a10ed23","927":"c479d2e6"}[chunkId] + ".chunk.css";
};